import React from 'react';

export const Practicaja = ({cliente, handleGenerarFicha, btnLoading}) => {
    return (
        <div>
            <div className="row">
                <div className="col-md-12 text-center">
                    <h6>Total:</h6>
                    <h5 className="text-success">
                        { new Intl.NumberFormat("en-US", {style: "currency", currency: "USD"}).format(cliente.anticipo) }
                    </h5>
                </div>
            </div>
            <div className="row mt-3">
                <div className="col mt-2 d-flex align-content-center justify-content-center">
                <button 
                        className="btn btn-primary" 
                        type="submit"
                        disabled={btnLoading}
                        onClick={() => handleGenerarFicha('practicaja')}
                    >
                        {btnLoading && <i className="spinner-border spinner-border-sm" role="status"></i>} Generar ficha de pago
                    </button>
                </div>
            </div>
        </div>
    )
}
